import { Component, OnInit, Input, Output, OnChanges, SimpleChanges, EventEmitter, ViewChild, ElementRef, NgZone, input, inject, AfterViewInit, AfterViewChecked, Inject, PLATFORM_ID } from '@angular/core';
import { Entry, Asset } from 'contentful';
import { GoogleMapsService } from '../../_services/google-maps.service';
import { zip, Subject, concat, from, interval, takeWhile } from 'rxjs';
import { OptionsFields, FormStep } from '../../_models/form-step.model';
import { LinkingBetweenComponentsService } from '../../_services/linking-between-components.service';
import { trigger, transition, style, animate } from '@angular/animations';
import { AnimationDriver } from '@angular/animations/browser';
import { isPlatformServer, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { FormControl } from '@angular/forms';
import { environment, googlemapskey } from '../../../enviroments/environment';
import { FormDataService } from '../../_services/form-data.service';
import { ScriptsInjectorService } from '../../_services/scripts-injector.service';
import { CssInjectorService } from '../../_services/css-injector.service'; 
import { ContentfulService } from '../../_services/contentful.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Observable, of, lastValueFrom } from 'rxjs';
import { FormBrandService } from '../../_services/form-brand.service';
import { LandingApiProgressService } from '../../_services/landing-api-progress.service';
import { FormSubmissionService } from  '../../_services/form-submission.service';
import { Console } from 'console';
import { WindowService } from '../../_services/window.service';
import { ActivatedRoute } from '@angular/router';
import { AddressResolutionService } from '../../_services/address-resolution.service';
import { TelemetryService } from '../../_services/telemetry.service';
import { TelemetryTransitionContextService } from '../../_services/telemetry-transition-context.service';

@Component({
  selector: 'app-form-step',
  standalone: false,
  templateUrl: './form-step.component-v1.html',
  styleUrl: './form-step.component-v1.css',
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms ease-in', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        animate('300ms ease-out', style({ opacity: 0 })),
      ]),
    ]),
  ],
})

export class FormStepComponentV1 implements OnInit, OnChanges, AfterViewChecked {
  @ViewChild('addressInput') addressInput!: ElementRef;
  addressControl = new FormControl('');
  houseImageUrl: string | null = null;
  formData: { [key: string]: any } = {};

  
  @Input() steps: any = [];
  @Input() step: any;
  @Input() currentStep: number = 0;
  @Input() totalSteps: number = 0; 
  @Output() next = new EventEmitter<void>();
  @Output() prev = new EventEmitter<void>();
  @Output() dataChanged = new EventEmitter<void>();

  private autocompleteInitialized = false;

  // Feature flags read once from query params
  private usePlacesNew = false;
  private developerMode = false;
  private geocodeCallCount = 0;
  private geocodeLastKey = '';
  private geocodeTriggerBySource: Record<string, number> = {};

  private apiKey = googlemapskey.key; 
  zipCode: string = '';
  address: string | null = '';
  city: string | null = '';
  state: string | null = '';
  formattedPhones: {[key: string]: string} = {};
  phoneFields: {[key: string]: { formatted: string, valid: boolean }} = {};
  error: string | null = '';

  brandSettings: any;

  zipError: string | null = null;
  isValidatingZip: boolean = false;
  private zipSubject = new Subject<string>();  

  conditionalFieldValidator: boolean = false;

  sliderTouched: { [key: string]: boolean } = {};

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private googleMapsService: GoogleMapsService,
    private linkComponent: LinkingBetweenComponentsService,
    private ngZone: NgZone,
    private formDataService: FormDataService,
    private scriptsInjectorService: ScriptsInjectorService,
    private cssInjectorService: CssInjectorService,
    private contentfulService : ContentfulService,
    private sanitizer: DomSanitizer,
    private formBrandService: FormBrandService,
    private landingApiProgressService: LandingApiProgressService,
    private formSubmissionService: FormSubmissionService,
    private window: WindowService,
    private activatedRoute: ActivatedRoute,
    private addressResolutionService: AddressResolutionService,
    private telemetryService: TelemetryService,
    private telemetryTransitionContext: TelemetryTransitionContextService
  ) {
    // Read feature flags once from query params 
    const qp = this.activatedRoute.snapshot.queryParams;
    const truthy = (v: string | undefined) => v === '1' || v === 'true' || v === 'yes';
    this.usePlacesNew = truthy(qp['usePlacesNew']);
    this.developerMode = truthy(qp['developer']);
   }

  private get isBrowser(): boolean {
    return !!this.window.window;
  }

  private get storage(): Storage | null {
    return isPlatformBrowser(this.platformId) ? localStorage : null;
  }

  async ngOnInit() {  
    await this.loadGoogleMaps();
    this.brandSettings = this.formBrandService.getCachedFormBrandSettings();
    this.setTextFormButtonsByStep(this.step.fields);
    this.formDataService.formData$.subscribe(data => {
      this.formData = data;        
      switch(this.step?.fields?.stepType) {
        case 'zip_code':
        case 'address':
        case 'address_image':
        case 'address_full_info_v1':
          this.trackGeocodeTrigger('formData$ subscription', data['Address'], data['Zip']);
          this.resolveAndApplyAddress(data['Address'], data['Zip'], 'formData$ subscription');
        break;
      }
    });

    
    this.formDataService.currentStep$.subscribe(step => {
      
      this.autocompleteInitialized = false;
      this.currentStep = step;            
      if(this.currentStep > 0) {
        switch(this.step?.fields?.stepType) {
          case 'zip_code':
          case 'address':
          case 'address_image':
          case 'address_full_info_v1':
            this.trackGeocodeTrigger('currentStep$ subscription', this.formData['Address'], this.formData['Zip']);
            this.resolveAndApplyAddress(this.formData['Address'], this.formData['Zip'], 'currentStep$ subscription');
          break;
        }
      }
      
      
      this.loadProgressBar(this.currentStep, this.totalSteps);
      this.initializeProgressDots(this.currentStep, this.totalSteps);      
    });

    
  }

  ngAfterViewChecked() {    
    if (this.isBrowser && this.addressInput?.nativeElement && !this.autocompleteInitialized && this.googleMapsService) {
      // Note: Google Maps autocomplete starts here, but only for the steps that require it and each time you change to a step that requires it
      this.initAutocomplete();
      this.autocompleteInitialized = true;

    }
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {        
    if (this.step?.fields?.configuration?.fields) {   
      this.applyDefaultValue();
      this.calculateDyniamicValues();      

      switch (this.step.fields.stepType) {
        case "dynamic":
          this.step?.fields?.configuration?.fields.forEach(async (field: any) => {            
            this.landingApiProgressService.prepareSave(field, this.currentStep);
            if(field.type === 'loader') {
              await new Promise(resolve => setTimeout(resolve, 50));            
            }
            
            if(field.dynamicFunctions && field.dynamicFunctions.length > 0) {
              field.dynamicFunctions.forEach(async (dynamicFunction: any) => {
                const formData = this.formDataService.getCurrentFormData();
                const site = (this.window.locationOrigin + this.window.locationPathname)
                
                var currentConditionalValue = formData[dynamicFunction.dynamicEvaluationKey]

                var conditionMet = this.evaluateCondition(
                  dynamicFunction.dynamicEvaluationValue,
                  dynamicFunction.conditionalOperator, 
                  currentConditionalValue,
                );

                if(conditionMet) {
                  var stepHTML = this.window.document?.getElementsByClassName("step")[0] as HTMLElement;
                  if(stepHTML) {                    
                    var stepTitle = this.window.document?.getElementById("steptitle");
                    if (stepTitle) {
                      stepHTML.removeChild(stepTitle)

                      const tempDiv = this.window.document?.createElement('div');
                      if (!tempDiv) {
                        return;
                      }
                      tempDiv.innerHTML = `<h2 id="steptitle" class="step-title">${dynamicFunction.dynamicTitle}</h2>`;
                      const dynamicTitle = tempDiv.firstChild as Node;
                      
                      if (dynamicTitle) {
                        stepHTML.prepend(dynamicTitle);
                      }
                                          
                    }
                  }
                  var sliderContainer = this.window.document?.getElementsByClassName("slider-container")[0] as HTMLElement;
                  if(sliderContainer) {
                    var sliderContainerLabel = this.window.document?.getElementsByClassName("slider-container")[0].getElementsByTagName("label")[0]
                    if(sliderContainerLabel) {
                      sliderContainer.removeChild(sliderContainerLabel)

                      const tempDiv = this.window.document?.createElement('div');
                      if (!tempDiv) {
                        return;
                      }
                      tempDiv.innerHTML = `<label>${dynamicFunction.dynamicLabel}</label>`;
                      const dynamicLabel = tempDiv.firstChild as Node;
                      
                      if (dynamicLabel) {
                        stepHTML.appendChild(dynamicLabel);
                      }
                    }
                  }


                  await this.initLoaderBar(field.settings.loaderTimeSec);
                  switch (dynamicFunction.dynamicFunctionType) {
                    case "ThankYouPage":

                      const lead = this.formSubmissionService.prepareLeadData(formData, site);
                      this.formSubmissionService.handleSubmissionResponse("DynamicFunction",lead)
                      
                      break;
                    case "Redirect":                      
                      if(dynamicFunction.dynamicValue1) {
                        //window.location.href = dynamicFunction.dynamicValue1 //JLFranco
                        if (dynamicFunction.dynamicValue1 && this.window.window) {
                          this.window.window.location.href = dynamicFunction.dynamicValue1;
                        }
                      }
                      break;
                    default:
                      break;
                  }
                }

              });
              
            }
          });                  
        break;      
        case "dropdown": 
          this.loadDropdownSettings(this.step, this.formData);


        break;
        default:
          this.step?.fields?.configuration?.fields.forEach((field: any) => {
            var indice = this.steps.findIndex((p:any) => JSON.stringify(p) === JSON.stringify(this.step));
            this.landingApiProgressService.prepareSave(field, indice); 
              if (field.type === 'disclosure_jornaya') {
                setTimeout(() => {            
                  this.handoffJornayaDisclosure(field);
                }, 10);
              } else if(field.type === 'loader') {
                console.log(this.step)
                setTimeout(() => {
                  this.initLoaderBar(field.loaderTimeSec)
                }, 100);
              } else {
                if(field.options) {
                  field.options.forEach((option: any) => {
                    // this.getContenfulAssetURL(option.assetID).subscribe(url => {
                    //   if (url) {              
                    //     option.safeUrl = url;
                    //   }
                    // });
                  });            
                }
              }        
          });
          break;
      }

    }

    this.cssInjectorService.injectCSS('form-step', this.step.fields.customStyle);    
    this.setTextFormButtonsByStep(this.step.fields);
  }

  isStepValid(): boolean {
    const currentStepConfig = this.step?.fields?.configuration?.fields || [];

    return currentStepConfig.every((field: any) => {
      const value = this.formData[field.key];
      if (field.validations?.required && Array.isArray(value)) {
        return value.length > 0;
      }

      if (field.validations?.required) {

        return !!value;
      }
      if (field.conditional) {
        const parentKey = this.getConditionalParentKey(field);
        const parentValue = this.formData[parentKey];

        return parentValue !== field.conditionalValue || !!this.formData[field.key];
      }
      if (field.key === 'ZipCode') {

        return this.formData['ZipCode'].length == 5 
      }  
      return true;
    });
  }

  getInputType(validations: any): string {
    if (validations?.min || validations?.max || validations?.dynamicMin || validations?.dynamicMax) return 'number';
    return 'text';
  }

  isOptionSelected(key: string, option: string): boolean {
    return this.formData[key]?.includes(option) || false;
  }

  onCheckboxChange(key: string, optionValue: string, event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    const currentValues: any[] = this.formData[key] || [];
    const newValues = isChecked
      ? [...currentValues, optionValue]
      : currentValues.filter(v => v !== optionValue);
    
    this.formDataService.updateFormData({ [key]: newValues });
    this.trackFieldInteraction(key, 'input', 'checkbox', 'change', newValues, optionValue);
  }

  //#region Zip Code / Google Addres

  goFindAddresses(zipCode: string) {
    if (zipCode && zipCode.length < 5) {
      this.city = null;
      this.state = null;
      return;
    }

    this.city = 'City'
    this.state = 'State'
    this.address = 'Address';

    this.formData['City'] = this.city;
    this.formData['State'] = this.state;
    this.formDataService.updateFormData(this.formData);


  }

  zipCodeValidator(zipCode: string, inputField: any) {
    if (zipCode.length < 5) {
      inputField.control.setErrors({ 'invalidLength': true });
      this.city = null;
      this.state = null;
      return;
    }
    // this.googleMapsService.getCityByZipCode(zipCode)
    //   .subscribe({
    //     next: (address) => {
    //       const obj = address;

    //       const targetZip = zipCode;
    //       const postalCodeComponent = obj.address_components.find((component: any) => 
    //           component.types.includes("postal_code") && 
    //           (component.long_name === targetZip || component.short_name === targetZip)
    //       );
    //       // console.log(postalCodeComponent ? `✅ Código postal ${targetZip} válido.` : "❌ Código postal inválido.");
    //       if(!postalCodeComponent) {
    //         this.city = null;
    //         this.state = null;
    //         inputField.control.setErrors({ 'invalidNotFound': true });
    //         return;
    //       }
          
    //       // Extraer ciudad y estado
    //       const localityComponent = obj.address_components.find((component: any) => 
    //           component.types.includes("locality") && 
    //           component.types.includes("political")
    //       );
    //       const stateComponent = obj.address_components.find((component: any) => 
    //           component.types.includes("administrative_area_level_1") && 
    //           component.types.includes("political")
    //       );
          
    //       // Asignar a variables
    //       const ciudad = localityComponent ? localityComponent.long_name : null;
    //       const estado = stateComponent ? stateComponent.short_name : null;
            

    //       this.city = ciudad
    //       this.state = estado
    //       this.address = address;

    //       this.formData['City'] = this.city;
    //       this.formData['State'] = this.state;
    //       this.formDataService.updateFormData(this.formData);

    //       this.error = null;
    //     },
    //     error: (err) => {
    //       this.error = 'Error al obtener la ciudad: ' + err.message;
    //       this.address = null;
    //     }
    //   });
  
    this.city = 'City'
    this.state = 'State'
    this.address = 'Address';

    this.formData['City'] = this.city;
    this.formData['State'] = this.state;
    this.formDataService.updateFormData(this.formData);

  
  
  }

  onZipInputChange(zip: string): void {
    this.formData['zip_code'] = zip;
    this.zipError = null;
    this.zipSubject.next(zip);
  }
  
  private async loadGoogleMaps() {
    if (!this.isBrowser) {
      return;
    }

    try {
      await this.googleMapsService.loadGoogleMapsApi(this.apiKey);
    } catch (error) {
    }
  }

  private initAutocomplete() {
    if (!this.isBrowser) {
      return;
    }

    if (!this.addressInput?.nativeElement || typeof google === 'undefined') {      
      return;
    }

    //#region Places New Flow
    if (this.usePlacesNew) {
      this.debugLog('[MAPS-DEBUG] Places New flow active – calling initAutocompletePlacesNew');
      this.ngZone.runOutsideAngular(() => {
        this.googleMapsService.initAutocompletePlacesNew(
          this.addressInput.nativeElement,
          (place: google.maps.places.PlaceResult) => {
            if (!place.geometry) {
              this.error = 'Please enter a valid US address.';
              this.houseImageUrl = null;
              this.debugLog('[MAPS-DEBUG] Place invalid or non-US – cleared input');
              return;
            }

            this.ngZone.run(() => {
              if (place.geometry?.location) {
                const lat = place.geometry.location.lat();
                const lng = place.geometry.location.lng();
                this.houseImageUrl = `https://maps.googleapis.com/maps/api/streetview?size=520x180&location=${lat},${lng}&fov=80&heading=70&pitch=0&key=${this.apiKey}`;
                this.debugLog('[MAPS-DEBUG] houseImageUrl set (Places New):', this.houseImageUrl);
              } else {
                this.houseImageUrl = null;
              }

              this.resolveAndApplyAddress(place.formatted_address || '', '', 'places-new-selection');
              this.error = null;
            });
          },
          this.debugLog.bind(this)
        );
      });
      return;
    }
    //#endregion Places New Flow

    this.ngZone.runOutsideAngular(() => {
      this.googleMapsService.initAutocomplete(
        this.addressInput.nativeElement,
        (place: google.maps.places.PlaceResult) => {
          if (!place.geometry) {
            this.error = 'Please enter a valid US address.';
            this.houseImageUrl = null;
            return;
          }
          
          this.ngZone.run(() => {
            if (place.geometry?.location) {
              const lat = place.geometry.location.lat();
              const lng = place.geometry.location.lng();
              this.houseImageUrl = `https://maps.googleapis.com/maps/api/streetview?size=520x180&location=${lat},${lng}&fov=80&heading=70&pitch=0&key=${this.apiKey}`;
            } else {
              this.houseImageUrl = null;
            }

            this.resolveAndApplyAddress(place.formatted_address || '', '', 'legacy-place-selection');
            this.error = null;
          });
        }
      );
    });
  }

  private async resolveAndApplyAddress(address: string, zip: string = '', source: string = 'unknown'): Promise<void> {
    if (!this.isBrowser || typeof google === 'undefined') {
      return;
    }

    const geocoderResult = await this.addressResolutionService.resolve(
      address,
      zip,
      source,
      this.debugLog.bind(this)
    );

    this.ngZone.run(() => {
      this.addressControl.setValue(address);
      if (!geocoderResult?.geometry?.location) {
        return;
      }

      const lat = geocoderResult.geometry.location.lat();
      const lng = geocoderResult.geometry.location.lng();
      this.houseImageUrl = `https://maps.googleapis.com/maps/api/streetview?size=520x180&location=${lat},${lng}&fov=80&heading=70&pitch=0&key=${this.apiKey}&language=en&region=us`;

      if (this.formData['Address'] !== undefined) {
        const streetNumber = geocoderResult.address_components.find(comp => comp.types.includes('street_number'))?.long_name || '';
        const route = geocoderResult.address_components.find(comp => comp.types.includes('route'))?.long_name || '';
        this.formData['Address'] = (streetNumber + ' ' + route).trim();
      }
      if (this.formData['City'] !== undefined) {
        this.formData['City'] = geocoderResult.address_components.find(comp => comp.types.includes('locality'))?.long_name || '';
      }
      if (this.formData['State'] !== undefined) {
        this.formData['State'] = geocoderResult.address_components.find(comp => comp.types.includes('administrative_area_level_1'))?.short_name || '';
      }
      if (this.formData['Zip'] !== undefined) {
        this.formData['Zip'] = geocoderResult.address_components.find(comp => comp.types.includes('postal_code'))?.long_name || '';
      }
      if (this.formData['Country'] !== undefined) {
        this.formData['Country'] = geocoderResult.address_components.find(comp => comp.types.includes('country'))?.long_name || '';
      }
    });
  }

//#endregion Zip Code / Google Addres

  private getCurrentField() {
    return this.step?.fields?.configuration?.fields?.[0];
  }  

  get isCardSelect(): boolean {
    return this.step.stepType.includes('card_select');
  }

  selectOption(key: string, option: OptionsFields, event: Event) {
    this.formData[key] = option.value;
    this.applySelectOption(key, option);
    this.trackFieldInteraction(key, 'button', 'radio', 'select', option.value, option.value);
    // Telemetry: this selection usually advances to the next step.
    this.telemetryTransitionContext.setPending({ source: 'option_auto_advance', triggerFieldKey: key });
  }

  selectOptionDynamic(key: string, option: OptionsFields, event: Event, selectOptionDynamic: string) {
    this.formData[key] = option.value;
    this.applySelectOption(key, option);
    this.trackFieldInteraction(key, 'button', 'radio', 'select', option.value, option.value);

    if(selectOptionDynamic === 'nextStep') {
      // Telemetry: dynamic option triggered auto-advance.
      this.telemetryTransitionContext.setPending({ source: 'option_auto_advance', triggerFieldKey: key });
      this.nextStep();
    }
  }

  applySelectOption(key: string, option: OptionsFields) {
    if (!this.isBrowser) return;

    var options = Array.prototype.slice.call(this.window.document?.getElementById(key)?.children)
    options.map((item: HTMLElement) => {
      if (item.id === option.value) {
        item.classList.add('selected');
      } else {
        item.classList.remove('selected');
      }
    });
  }

  async validateConditionalField(key: string, option: OptionsFields, event: Event, field: any) {
    this.formData[key] = option.value;
    this.trackFieldInteraction(key, 'button', 'radio', 'select', option.value, option.value);
    for (let i = 0; i < field.length; i++) {
      var _field = field[i]
      if (_field.conditional == true) {
        if (_field.conditionalValue == option.value) {
          this.formDataService.updateFormData(this.formData);

        } else {
          this.formDataService.updateFormData(this.formData);
          // Telemetry: conditional selection advanced automatically.
          this.telemetryTransitionContext.setPending({ source: 'conditional_auto_advance', triggerFieldKey: key });
          this.nextStep();
        }
      } else {
      }
    }



    if (option.value == field.conditionalValue) {
    }  
  }

  nextStep() {
    this.linkComponent.sendTrigger(true);
  }

  getInterpolationData(): { [key: string]: any } {

    let fieldConditional = false;
    var conditionalKey;
    var conditionalValue;
    
    if(this.step?.fields?.configuration?.fields === undefined || this.step?.fields?.configuration?.fields === null) {
      return {};
    }
    this.step.fields.configuration.fields.forEach((field: any) => {
      var fieldValidations = field.validations;

      conditionalKey = fieldValidations?.conditionalKey ? fieldValidations?.conditionalKey : null;
      if(conditionalKey !== undefined && conditionalKey !== null) {

        switch(fieldValidations?.conditionalOperator) {
          case '=':
            if(this.formData[conditionalKey] === fieldValidations?.conditionalValue) {
              fieldConditional = true;
            }
          break;
          case '>':
            if(this.formData[conditionalKey] > fieldValidations?.conditionalValue) {

              fieldConditional = true;
            }
            break;

        }

      }
    });

      
    var cso = ((this.formData['EstimatedHomeValue'] || 0) * 0.9) - 10000 - (this.formData['LoanAmount'] || 0);
    cso = Math.round(cso / 1000) * 1000;
    
    const maxCashOut = ((this.formData['EstimatedHomeValue'] || 0) * 0.9) - 10000 - (this.formData['LoanAmount'] || 0);
    const maxCashOutRounded = Math.round(maxCashOut / 1000) * 1000;
    this.formData['maxCashOut'] = maxCashOutRounded > 0 ? maxCashOutRounded : 0;
    
    
    if(cso < 0) {
      cso = 0;
    }   



    if(conditionalKey !== undefined && conditionalKey !== null) {
      if(!fieldConditional) {
        cso = 0;
      }
    }    

    
  
    var cashUsage = "";
    if(this.formData['CashUsage'] !== undefined && this.formData['CashUsage'] !== null) {
      var aceptedCashUsage: string[] = [];
      this.formData['CashUsage'].forEach((e: any) => {
        if(e != 'noCashNeeded') {
          aceptedCashUsage.push(e);
        }
      });
      cashUsage = aceptedCashUsage.join(", "); this.formData['CashUsage'];


     }
    

    return {
      // CashOut: cso,
      maxCashOut: maxCashOutRounded > 0 ? maxCashOutRounded : 0,  // nuevo key
      state: this.state,
      city: this.city,
      address: this.address,
      cashUsage: cashUsage
    };
  }

  getSliderMax(field: any): number {
    const dynamicMax = field?.validations?.dynamicMax;

    if (dynamicMax != null && dynamicMax !== field.key) {
    const value = this.getInterpolationData()[dynamicMax];

      if (value !== undefined && value !== null) {
        return value;
      }
    }
        
    return field?.validations?.max ?? 0;
  }


  calculateDynamicMinMax(event: any): { [key: string]: any } {
    return {
      


    }
  }

  calculateDyniamicValues() {
    var fieldConditional;
    var conditionalKey;
    var conditionalValue;
    this.step.fields.configuration.fields.forEach((field: any) => {
      var fieldValidations = field.validations;

      conditionalKey = fieldValidations?.conditionalKey ? fieldValidations?.conditionalKey : null;
      if(conditionalKey !== undefined && conditionalKey !== null) {

        switch(fieldValidations?.conditionalOperator) {
          case '=':
            if(this.formData[conditionalKey] === fieldValidations?.conditionalValue) {
              fieldConditional = true;
            }
          break;
          case '>':
            if(this.formData[conditionalKey] > fieldValidations?.conditionalValue) {

              fieldConditional = true;
            }
            break;

        }

      }
    });


    var sliderTouchedString = this.storage?.getItem('sliderTouched') || '{}';
    var sliderTouched = JSON.parse(sliderTouchedString);


    // console.log('sliderTouched:', sliderTouched);

    var cso = ((this.formData['EstimatedHomeValue'] || 0) * 0.9) - 10000 - (this.formData['LoanAmount'] || 0);
    cso = Math.round(cso / 1000) * 1000;

    if(sliderTouched['CashOut'] != true) {
      if(cso < 0) {
        cso = 0;
        this.formData['CashOut'] = 0;
      } else {
        this.formData['CashOut'] = cso; 
      }

      if(conditionalKey !== undefined && conditionalKey !== null) {
        if(!fieldConditional) {
          cso = 0;
          this.formData['CashOut'] = 0; 
        }
      }

    } else {
      if(cso < this.formData['CashOut']) {
        if(cso < 0) {
          cso = 0;
          this.formData['CashOut'] = 0;
        } else {
          this.formData['CashOut'] = cso; 
        }
  
        if(conditionalKey !== undefined && conditionalKey !== null) {
          if(!fieldConditional) {
            cso = 0;
            this.formData['CashOut'] = 0; 
          }
        }
      } else if(this.formData['CashOut'] == 0) {
        this.formData['CashOut'] = 0;
      } else if(this.formData['CashOut'] == 0 && cso > 0) {
        // this.formData['CashOut'] = cso;
      }
      
      if(conditionalKey !== undefined && conditionalKey !== null) {
        if(!fieldConditional) {
          cso = 0;
          this.formData['CashOut'] = 0; 
        }
      }

    }

  }

  handleConditionalSelection(key: string, value: any, fields: any[]) {
    this.formData[key] = value;

    const conditionalField = fields.find(f => f.conditional);
    if (conditionalField && value !== conditionalField.conditionalValue) {
      this.formData[conditionalField.key] = null;
    }

    this.dataChanged.emit();
  }

  getConditionalParentKey(conditionalField: any): string {
    const parentField = this.step?.fields?.configuration?.fields?.find(
      (f: any) => !f.conditional && f.key !== conditionalField.key
    );
    return parentField?.key || '';
  }

  loadProgressBar(currentStep: number, totalSteps: number) {
    if (!this.isBrowser) {
      return;
    }

    //var progressBar = document.querySelector(".dynamic-progress-bar") as HTMLElement; //JLFranco
    var progressBar = this.window.document?.querySelector(".dynamic-progress-bar") as HTMLElement;
    var _currentStep = (currentStep + 1)

    progressBar?.style.setProperty("--progress", `${(_currentStep / totalSteps) * 100}%`);
  }

  initializeProgressDots(currentStep: number, totalSteps: number) {
    if (!this.isBrowser) {
      return;
    }

    //const progressDots = document.getElementById('progress-dots'); //JLFranco
    const progressDots = this.window.document?.getElementById('progress-dots');
    
    if(progressDots == null) return;
    
    progressDots.innerHTML = '';
    
    for (let i = 0; i < totalSteps; i++) {
      //const dot = document.createElement('div'); //JLFranco
      const dot = this.window.document?.createElement('div');
      if (!dot) {
        continue;
      }
      dot.className = 'dot';
      if (i === 0) dot.classList.add('active');
      progressDots.appendChild(dot);
    }
    this.updateProgressBar(this.currentStep, totalSteps);
  }

  updateProgressBar(currentStep: number, totalSteps: number) {
    if (!this.isBrowser) {
      return;
    }

    const progress = ((currentStep + 1) / totalSteps) * 100;

    //const dots = document.querySelectorAll('.dot'); //JLFranco
    const dots = this.window.document?.querySelectorAll('.dot') ?? [];
    dots.forEach((dot, index) => {
        if (index <= currentStep) {
            dot.classList.add('active');
        } else {
            dot.classList.remove('active');
        }
    });
    
  }

  onlyNumbers(event: KeyboardEvent) {
    const pattern = /[0-9]/;
    return pattern.test(event.key);
  }

  limitTo10Digits(fieldKey: string) {
    if (this.formData[fieldKey] && this.formData[fieldKey].length > 10) {
      this.formData[fieldKey] = this.formData[fieldKey].substring(0, 10);
      this.dataChanged.emit();
    }
  }

  validatePhoneNumber(event: Event, fieldKey: string, inputField: any) {
    const input = event.target as HTMLInputElement;
    const phone = input.value;
    const phoneLength = 10;

    if (phone !== '') {
      if(!(phone.length === phoneLength)) {
        inputField.control.setErrors({ 'invalidLength': true });

      }
    }
    this.trackFieldInteraction(fieldKey, 'input', 'phone', 'blur', phone);
    // console.log(fieldConfig)
  }  

  validateZipCode(event: Event, fieldKey: string, inputField: any) {
    const input = event.target as HTMLInputElement;
    const zipCode = input.value;
    const zipCodeLength = 5;
    
    if (zipCode !== '') {
      if(!(zipCode.length === zipCodeLength)) {
        inputField.control.setErrors({ 'invalidLength': true });
      }
    }
    this.trackFieldInteraction(fieldKey, 'input', 'zip', 'blur', zipCode);
  }  

  validateEmailFormatOnChange(event: Event, fieldKey: string, inputField: any) {
    // const currentStep = this.step?.fields?.configuration?.fields || [];
    const input = event.target as HTMLInputElement;
    const email = input.value;
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;   

    // const fieldConfig = currentStep.find((field: any) => field.key === fieldKey);
    
    if (!emailPattern.test(email) && email !== '') {
      inputField.control.setErrors({ 'invalidEmail': true });        
      // fieldConfig.validations.format = false;
    }
    this.trackFieldInteraction(fieldKey, 'input', 'email', 'blur', email);
  }

  // Telemetry: model-level tracking for fields bound with ngModel.
  onFieldModelChange(field: any, rawValue: unknown, event?: Event): void {
    const fieldType = String(field?.type || '').toLowerCase();
    const fieldKey = String(field?.key || '');
    const controlType = this.resolveControlType(fieldType, fieldKey);
    const elementType = this.resolveElementType(controlType);
    
    if (this.isSliderStep()) {
      return;
    }

    this.trackFieldInteraction(fieldKey, elementType, controlType, 'change', rawValue);
  }

  applyDefaultValue() {
    const currentStepConfig = this.step?.fields?.configuration?.fields || [];
    
    currentStepConfig.forEach((field: any) => {
      
      if(!this.formData[field.key] && field.defaultValue) {
        this.formData[field.key] = field.defaultValue;
      }

      
      
    });
    
    this.formDataService.updateFormData(this.formData);
  } 
  
  setTextFormButtonsByStep(fields: FormStep["fields"]) {
    if (!this.isBrowser) {
      return;
    }
    
    var nextButtonText = fields.nextButtonText ? fields.nextButtonText : 'Next';
    var backButtonText = fields.backButtonText ? fields.backButtonText : 'Go Back';
    
    var nextButtons = this.window.document?.getElementsByClassName('continue-button') ?? [];
    var backButtons = this.window.document?.getElementsByClassName('goback-button') ?? [];

    if( nextButtons && nextButtons.length > 0) {      

      for(let i = 0; i < nextButtons.length; i++) {
        nextButtons[i].textContent = nextButtonText;
      }
    };
    
    if(backButtons && backButtons.length > 0) {
      backButtons[0].textContent = backButtonText;
    };
  }

  async _getContenfulAssetURL(id: string | null) {
    
    await from(this.contentfulService.getAsset(id)).subscribe({
      next: (asset: Asset) => {
        var imageURL =  asset.fields.file?.url as string;
        var  _imageURL =`https:${imageURL}`                 
        return _imageURL;
      },
      error: (err) => {
        console.error('Error:', err);
   
      }
    });

  }

  getContenfulAssetURL(id: string | null): Observable<string | null> {
    if (!id) return of(null);
    
    return new Observable<string | null>(observer => {
      this.contentfulService.getAsset(id)
        .then((asset: Asset) => {
          const imageURL = asset.fields.file?.url as string;
          const _imageURL = `https:${imageURL}`;
          observer.next(_imageURL);
          observer.complete();
        })
        .catch((err) => {
          console.error('Error:', err);
          observer.next(null);
          observer.complete();
        });
    });
  }

  replaceVariables(text: string, params: { [key: string]: any }): string {
    if (!text || !params) return text;
    
    return text.replace(/\{\{(\w+)\}\}/g, (match, variableName) => {
      if (params[variableName] !== undefined) {
        return params[variableName];
      }
    
      const lowerKey = variableName.toLowerCase();
      for (const key in params) {
        if (key.toLowerCase() === lowerKey) {
          return params[key];
        }
      }    
      return match;
    });
  }

  private handoffJornayaDisclosure(field: any, attempt: number = 0): void {
    // #disclaimer1 is a temporary early DOM target for Jornaya/DataVerify while ngSwitch has not rendered the final step yet.
    // Once #disclaimer2 exists, it becomes the only official TCPA disclosure to avoid duplicate IDs/disclosures.
    this.logJornayaDebug('disclosure-handoff:started', {
      attempt,
      hasFieldContent: !!field.content,
    });

    const doc = this.window.document;
    if (!doc) {
      return;
    }

    const disclosureContent = doc.querySelector('#tcpaDisclosureContent') as HTMLElement | null;
    if (!disclosureContent) {
      this.logJornayaDebug('disclosure-handoff:missing-content-target');
      return;
    }

    const brandDisclosure = this.getBrandDisclosureText();
    if (brandDisclosure) {
      // Brand TCPA text has the highest priority because it comes from TCPABrandID/DisclosID configuration.
      this.logJornayaDebug('disclosure-handoff:brand', {
        disclosureLen: brandDisclosure.length,
      });
      disclosureContent.innerHTML = brandDisclosure;
      this.removeDisclosureFallbackTarget();
      this.removeDisclaimerBuffer();
      return;
    }

    if (field.content) {
      // Contentful already populated #tcpaDisclosureContent through the template; remove the temporary fallback target.
      this.logJornayaDebug('disclosure-handoff:contentful', {
        disclosureLen: (field.content || '').length,
      });
      this.removeDisclosureFallbackTarget();
      this.removeDisclaimerBuffer();
      return;
    }

    const fallbackDisclosure = this.getDisclaimerBufferDisclosureHtml();
    if (fallbackDisclosure) {
      // No brand/Contentful text exists, so use the disclosure DataVerify injected into the early buffer.
      this.logJornayaDebug('disclosure-handoff:fallback-buffer', {
        disclosureLen: fallbackDisclosure.length,
      });
      disclosureContent.innerHTML = fallbackDisclosure;
      this.removeDisclosureFallbackTarget();
      this.removeDisclaimerBuffer();
      return;
    }

    if (attempt < 15) {
      // DataVerify can populate #srDisclosure asynchronously; wait briefly before giving up on the buffer.
      this.logJornayaDebug('disclosure-handoff:waiting-fallback', {
        attempt,
      });
      setTimeout(() => this.handoffJornayaDisclosure(field, attempt + 1), 100);
      return;
    }

    this.logJornayaDebug('disclosure-handoff:fallback-timeout');
    this.removeDisclaimerBuffer();
  }

  private getBrandDisclosureText(): string {
    // Brand disclosure overrides Contentful fallback when TCPABrandID/DisclosID settings are available.
    if (!this.brandSettings) {
      return '';
    }

    if (this.brandSettings.CO == '1') {
      return this.replaceVariables(this.brandSettings.disclousureTextGeneral || '', this.brandSettings);
    }

    return this.replaceVariables(this.brandSettings.disclousure1TextProd || '', this.brandSettings);
  }

  private getDisclaimerBufferDisclosureHtml(): string {
    // Read only the text/html that Jornaya/DataVerify injected into the early buffer.
    // Remove nested leadid_tcpa_disclosure inputs so the final disclosure keeps a single valid ID.
    const srDisclosure = this.window.document?.querySelector('#disclaimer1 #srDisclosure') as HTMLElement | null;
    if (!srDisclosure) {
      return '';
    }

    const clone = srDisclosure.cloneNode(true) as HTMLElement;
    clone.querySelectorAll('#leadid_tcpa_disclosure').forEach(element => element.remove());
    return clone.innerHTML.trim();
  }

  private removeDisclosureFallbackTarget(): void {
    // When brand or Contentful provides the disclosure, #srDisclosure is no longer needed in the final DOM.
    this.logJornayaDebug('disclosure-handoff:remove-final-fallback-target');
    this.window.document?.querySelector('#disclaimer2 #srDisclosure')?.remove();
  }

  private removeDisclaimerBuffer(): void {
    // Remove the early buffer after handoff so Jornaya/validators do not see two TCPA disclosure targets.
    this.logJornayaDebug('disclosure-handoff:remove-buffer');
    this.window.document?.querySelector('#disclaimer1')?.remove();
  }

  private isDebugJornayaEnabled(): boolean {
    const search = this.window.locationSearch;
    if (!search) return false;
    const value = new URLSearchParams(search).get('debugJornaya')?.trim().toLowerCase();
    return value === '1' || value === 'true' || value === 'yes';
  }

  private logJornayaDebug(stage: string, details: Record<string, unknown> = {}): void {
    if (!this.isDebugJornayaEnabled()) return;
    console.log(`[JORNAYA-DEBUG][form-step] stage=${stage}`, details);
  }

  initLoaderBar(loaderTimeSec: number): Promise<void> {
    if (!this.isBrowser) {
      return Promise.resolve();
    }

    if(!loaderTimeSec) {
        loaderTimeSec = 2.5
    }
  return new Promise((resolve) => {
    const total = 100;
    let progress = 0;
    const loaderBar = this.window.document?.querySelector(".dynamic-loader-bar") as HTMLElement;

    if (loaderBar) {
      loaderBar.style.setProperty("--loaderprogress", `${(progress / total) * 100}%`);
    }

    const intervalMs = (loaderTimeSec * 1000) / total;
    const subscription = interval(intervalMs)
      .pipe(takeWhile(() => progress < total))
      .subscribe({
        next: () => {
          progress++;
          if (loaderBar) {
            loaderBar.style.setProperty("--loaderprogress", `${(progress / total) * 100}%`);
          }
        },
        complete: () => resolve()
      });
  });
}


  // Move this function to Utils
  private evaluateCondition(value: any, operator: string = '==', target: any): boolean {
    switch (operator) {
      case '>':
        return Number(target) > Number(value);
      case '>=':
        return Number(target) >= Number(value);
      case '<':
        return Number(target) < Number(value);
      case '<=':
        return Number(target) <= Number(value);
      case '=':
        return target == value;
      case '==':
        return target == value;
      case '===':
        return target === value;
      case '!=':
        return target != value;
      case '!==':
        return target !== value;
      case 'includes':
        return String(target).includes(String(value));
      case 'startsWith':
        return String(target).startsWith(String(value));
      case 'endsWith':
        return String(target).endsWith(String(value));
      default:
        return false;
    }
  }


  private loadDropdownSettings(step: any, formData: any) {




  }

  //#region Places New – debug helper

  // Logs a message to the console only when `developer=1|true|yes` is in the URL.
  
  private debugLog(msg: string, ...args: any[]): void {
    if (this.developerMode && this.isBrowser) {
      console.log(msg, ...args);
    }
  }

  private trackGeocodeTrigger(source: string, address: string, zip: string = ''): void {
    const normalizedAddress = (address || '').trim().toLowerCase();
    const normalizedZip = (zip || '').trim().toLowerCase();
    const key = `${normalizedAddress}|${normalizedZip}`;

    this.geocodeCallCount += 1;
    this.geocodeTriggerBySource[source] = (this.geocodeTriggerBySource[source] || 0) + 1;
    const isDuplicateKey = key === this.geocodeLastKey;
    this.geocodeLastKey = key;

    this.debugLog('[MAPS-DEBUG] [ADDR] EVENT', {
      source,
      callCount: this.geocodeCallCount,
      triggerBySource: { ...this.geocodeTriggerBySource },
      address,
      zip,
      normalizedKey: key,
      duplicateOfPrevious: isDuplicateKey,
    });
  }

  // Telemetry: slider interaction with bucketed value.
  onSliderInteraction(fieldKey: string, rawValue: unknown): void {
    this.trackFieldInteraction(fieldKey, 'input', 'slider', 'commit', rawValue);
  }

  onSliderTouched(field: any) {
    var sliderTouchedString = this.storage?.getItem('sliderTouched') || '{}';
    var sliderTouched = JSON.parse(sliderTouchedString);
  
    sliderTouched[field.key] = true;
    sliderTouchedString = JSON.stringify(sliderTouched);

    this.storage?.setItem('sliderTouched', sliderTouchedString);
  }

  // Telemetry: unified field interaction event with PII-safe payload.
  private trackFieldInteraction(
    fieldKey: string,
    elementType: string,
    controlType: string,
    interactionType: string,
    rawValue: unknown,
    selectedOptionId?: string
  ): void {
    const basePayload: Record<string, string | number | boolean> = {
      fieldKey,
      elementType,
      controlType,
      interactionType,
      hasValue: this.hasValue(rawValue),
      stepId: this.step?.sys?.id || '',
      stepType: this.step?.fields?.stepType || '',
      stepIndex: this.currentStep,
    };

    if (this.isNumericControl(controlType)) {
      const numericValue = Number(rawValue);
      basePayload['valueBucket'] = this.getNumericBucket(numericValue);
    } else if (this.isTextControl(controlType)) {
      const text = rawValue == null ? '' : String(rawValue);
      basePayload['valueLength'] = text.length;
    }

    if (selectedOptionId) {
      basePayload['selectedOptionId'] = selectedOptionId;
    }

    this.telemetryService.trackEvent('field_interaction', basePayload);
  }

  private resolveControlType(fieldType: string, fieldKey: string): string {
    if (fieldType.includes('email')) return 'email';
    if (fieldType.includes('phone')) return 'phone';
    if (fieldType.includes('zip')) return 'zip';
    if (fieldType.includes('checkbox')) return 'checkbox';
    if (fieldType.includes('dropdown')) return 'dropdown';
    if (fieldType.includes('single_option')) return 'radio';
    if (fieldType.includes('address') || fieldKey.toLowerCase().includes('address')) return 'address';
    if (fieldType.includes('slider')) return 'slider';
    return 'text';
  }

  private resolveElementType(controlType: string): string {
    if (controlType === 'dropdown') return 'select';
    if (controlType === 'radio') return 'button';
    return 'input';
  }

  private isNumericControl(controlType: string): boolean {
    return controlType === 'slider';
  }

  private isSliderStep(): boolean {
    return String(this.step?.fields?.stepType || '').toLowerCase().includes('slider');
  }

  private isTextControl(controlType: string): boolean {
    return ['text', 'email', 'phone', 'zip', 'address'].includes(controlType);
  }

  private hasValue(rawValue: unknown): boolean {
    if (Array.isArray(rawValue)) return rawValue.length > 0;
    if (rawValue === null || rawValue === undefined) return false;
    return String(rawValue).trim() !== '';
  }

  private getNumericBucket(value: number): string {
    if (Number.isNaN(value)) {
      return 'unknown';
    }

    const size = 50000;
    const start = Math.floor(value / size) * size;
    const end = start + size;
    return `${start}-${end}`;
  }

  //#endregion Places New – debug helper

}
